var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardExpired = function SvgCardExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 137,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CardExpired_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.63 136.148c37.36 0 67.648-30.287 67.648-67.648C144.278 31.14 113.99.852 76.63.852 39.268.852 8.98 31.14 8.98 68.5s30.288 67.648 67.648 67.648Z",
    fill: "#367CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.045 48.485-19.235 58.088a8.92 8.92 0 0 1-11.271 5.665L77.611 97.693l-2.737-11.727 15.183-9.22-6.067-16.584 1.208-1.582 1.957-2.566 6.528-8.557-6.262-18.087 7.954-9.046 51.008 16.89a8.923 8.923 0 0 1 5.166 4.463 8.91 8.91 0 0 1 .496 6.808Z",
    fill: "#262BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.735 97.429a8.252 8.252 0 0 1-2.587 3.804 8.245 8.245 0 0 1-12.216-1.94c-1.281-2.06-1.745-4.616-.931-7.074a8.206 8.206 0 0 1 4.969-5.12 8.245 8.245 0 0 1 10.765 10.33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.982 98.315a8.285 8.285 0 0 1-10.995-5.743 8.287 8.287 0 0 1 15.034-6.451c-2.258.889-3.766 2.79-4.58 5.249-.814 2.458-.773 4.983.541 6.945Z",
    fill: "#8386E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.495 58.065a1.526 1.526 0 0 1-1.927.968l-1.37-.453 1.957-2.566.371.124a1.525 1.525 0 0 1 .969 1.927ZM110.631 63.788l-15.688-5.194a1.524 1.524 0 1 0-.959 2.894l15.688 5.195a1.525 1.525 0 0 0 .959-2.895ZM133.735 71.439l-15.688-5.195a1.525 1.525 0 0 0-.959 2.895l15.688 5.194a1.525 1.525 0 0 0 .959-2.894Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.801 97.84 7.764 9.205-46.555 7.113a8.93 8.93 0 0 1-6.63-1.629 8.928 8.928 0 0 1-3.535-5.84L2.603 46.198a8.919 8.919 0 0 1 7.47-10.163l39.183-5.985-2.978 11.67 13.793 13.27-1.93 10.59-.58 3.172-.356 1.958L70.14 82.73l-9.338 15.11Z",
    fill: "#262BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.913 44.446-11.525 1.76a3.649 3.649 0 0 0-3.056 4.159l1.025 6.712a3.65 3.65 0 0 0 4.159 3.056l11.525-1.76a3.649 3.649 0 0 0 3.056-4.16l-1.026-6.711a3.649 3.649 0 0 0-4.158-3.056ZM34.469 69.196l-16.336 2.496a1.525 1.525 0 1 0 .46 3.014L34.93 72.21a1.525 1.525 0 0 0-.46-3.014ZM58.141 65.58l-.579 3.172-14.91 2.277a1.523 1.523 0 1 1-.462-3.012l15.951-2.438Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.14 21.72-7.543-6.407 6.638-3.227.905 9.633ZM67.484 23.684l5.177-4.373.452 4.817-5.63-.444Z",
    fill: "#262BA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CardExpired_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .852)",
    d: "M0 0h150v135.296H0z"
  })))));
};
export default SvgCardExpired;